import React, { useState, useContext } from "react";
import { Typography, Button, Box, List, ListItem, Tooltip } from "@mui/material";
import CommonAccordion from "../../custom-components/CommonAccordion";
import { ReactComponent as GenerateButton } from "../../../images/generateButton.svg";
import { useLocation, useNavigate } from "react-router-dom";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";
import { LoadingModalContext } from "../../main-pages/ServicePage";
import CommonDownload from "../../custom-components/CommonDownload";
import { flattenArray, flattenObject } from "../../../utils/dataFlatteners"
import CommonCopy from "../../custom-components/CommonCopy";
import { generateFeatureFileToolCalling } from "../../../services/webServices";
const APITestCaseImported = (props) => {

    // console.log(props, 'propsssssssss');

    const navigate = useNavigate();
    const location = useLocation();
    const nextButton = !!props.testcaseNextButton ? [props.testcaseNextButton] : [];
    // const downloadButton = !!props.javaSeliniumDownloadButton ? [props.javaSeliniumDownloadButton] : [];
    // const rpfDownloadButton = !!props.robotFrameworkDownloadButton ? [props.robotFrameworkDownloadButton] : [];


    const [downloadOpen, setDownloadOpen] = useState(false);
    const [activeThumb, setActiveThumb] = useState(null);
    const [isCopied, setIsCopied] = useState(false);
    const { setLoadingState } = useContext(LoadingModalContext);
    const [isDownloadDisabled, setIsDownloadDisabled] = useState(true);
    const [showPopup, setShowPopup] = useState(false);
    // const defaultTestCasesExpanded = !props.IntroduceSCHEMA || !props.featureFile;
    const defaultTestCasesExpanded =!props.IntroduceSCHEMA && (!props.featureFile || props.featureFile.length === 0);
    const [featureFileData, setFeatureFileData] = useState(null);
    const [testCaseData, setTestCaseData] = useState(props.generateTestCasesData)

    const handleDownloadClick = () => {
        setDownloadOpen(true);
    };

    const handleCloseDownload = () => {
        setDownloadOpen(false);
    }
    const handleCopyClick = () => {
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 2000);
    };

    const handleThumbClick = (thumbType) => {
        setActiveThumb((prev) => (prev === thumbType ? null : thumbType));
    };

    const formatTestPlan = (testPlanData) => {
        const formattedTestPlan = {};
        Object.entries(testPlanData).map(([key, value]) => {
            // console.log(typeof value);
            // console.log(value)
            if (Array.isArray(value)) {
                return (formattedTestPlan[key] = flattenArray(value));
            }
            if (!!value && typeof value === "object") {
                return (formattedTestPlan[key] = flattenObject(value));
            }
            return (formattedTestPlan[key] = value);
        });
        // console.log(formattedTestPlan)
        return formattedTestPlan;
    };
    const formatValue = (value) => {
        // console.log("Value", value);
        if (Array.isArray(value)) {
            return flattenArray(value);
        }
        if (value && typeof value === 'object') {
            return (flattenObject(value));
        }
        return value;
    };


    const handlePromptsPopup = () => {
        setShowPopup(true);
    }
    const handleClosePopup = () => {
        setShowPopup(false);
    }


    return (
        <Box>
            <CommonAccordion
                summary={"Test Case Imported"}
                details={
                    <Box sx={{ backgroundColor: '#fff', borderRadius: 1, p: 2, marginTop: '-15px' }}>


                        <Typography
                            variant="subtitle1"
                            gutterBottom
                            sx={{

                                color: '#545F71'
                            }}
                        >
                            Test Case ID
                        </Typography>

                        <Typography variant="body1" gutterBottom>
                            {formatValue(testCaseData["Test Case ID"] || "")}

                        </Typography>

                        <Typography variant="subtitle1" gutterBottom>
                            <Typography
                                variant="subtitle1"
                                gutterBottom
                                sx={{

                                    color: '#545F71'
                                }}
                            >
                                Test Case Title</Typography>
                        </Typography>

                        <Typography variant="body1" gutterBottom>
                            {formatValue(testCaseData["Test Case Title"] || "")}
                        </Typography>

                        <Typography variant="subtitle1" gutterBottom>
                            <Typography
                                variant="subtitle1"
                                gutterBottom
                                sx={{

                                    color: '#545F71'
                                }}
                            >
                                API Endpoint</Typography>
                        </Typography>
                        <Typography variant="body1" gutterBottom>{formatValue(testCaseData["API Endpoint"] || "")}</Typography>
                        <Typography variant="subtitle1" gutterBottom>
                            <Typography
                                variant="subtitle1"
                                gutterBottom
                                sx={{

                                    color: '#545F71'
                                }}
                            >
                                Method</Typography>
                        </Typography>
                        <Typography
                            variant="body1"
                            dangerouslySetInnerHTML={{
                                __html: formatValue(testCaseData["Method"] || "").toString().replace(/\n/g, "<br>"),
                            }}
                        />


                        <Typography variant="subtitle1" gutterBottom>
                            <Typography
                                variant="subtitle1"
                                gutterBottom
                                sx={{

                                    color: '#545F71'
                                }}
                            >
                                Test Description</Typography>
                        </Typography>

                        <Typography
                            variant="body1"
                            dangerouslySetInnerHTML={{
                                __html: formatValue(testCaseData["Test Description"] || "").toString().replace(/\n/g, "<br>"),
                            }}
                        />

                        <Typography variant="subtitle1" gutterBottom>
                            <Typography
                                variant="subtitle1"
                                gutterBottom
                                sx={{

                                    color: '#545F71'
                                }}
                            >
                                Test Steps</Typography>
                        </Typography>

                        <Typography
                            variant="body1"
                            dangerouslySetInnerHTML={{
                                __html: formatValue(testCaseData["Test Steps"] || "").toString().replace(/\n/g, "<br>"),
                            }}
                        />

                        <Typography variant="subtitle1" gutterBottom>
                            <Typography
                                variant="subtitle1"
                                gutterBottom
                                sx={{

                                    color: '#545F71'
                                }}
                            >
                                Input Data</Typography>
                        </Typography>
                        <Typography
                            variant="body1"
                            dangerouslySetInnerHTML={{
                                __html: formatValue(testCaseData["Input Data"] || "").toString().replace(/\n/g, "<br>"),
                            }}
                        />
                        <Typography variant="subtitle1" gutterBottom>
                            <Typography
                                variant="subtitle1"
                                gutterBottom
                                sx={{

                                    color: '#545F71'
                                }}
                            >
                                Expected Result</Typography>
                        </Typography>
                        {/* <Typography variant="body1" gutterBottom>{testCaseData["Test Steps"]}</Typography> */}
                        <Typography
                            variant="body1"
                            dangerouslySetInnerHTML={{
                                __html: formatValue(testCaseData["Expected Result"] || "").toString().replace(/\n/g, "<br>"),
                            }}
                        />

                        <Typography variant="subtitle1" gutterBottom>
                            <Typography
                                variant="subtitle1"
                                gutterBottom
                                sx={{

                                    color: '#545F71'
                                }}
                            >
                                Category</Typography>
                        </Typography>

                        <Typography
                            variant="body1"
                            dangerouslySetInnerHTML={{
                                __html: formatValue(testCaseData["Category"] || "").toString().replace(/\n/g, "<br>"),
                            }}
                        />
                        <Typography variant="subtitle1" gutterBottom>
                            <Typography
                                variant="subtitle1"
                                gutterBottom
                                sx={{

                                    color: '#545F71'
                                }}
                            >
                                Sub-Category</Typography>
                        </Typography>
                        <Typography
                            variant="body1" gutterBottom>{formatValue(testCaseData["Sub-Category"] || "")}</Typography>

                        {/* <Typography variant="subtitle1" gutterBottom>
                            <Typography
                                variant="subtitle1"
                                gutterBottom
                                sx={{

                                    color: '#545F71'
                                }}
                            >
                                Type</Typography>
                        </Typography>
                        <Typography
                            variant="body1">
                            {formatValue(testCaseData["Type"])}
                        </Typography>
                        <Typography variant="subtitle1" gutterBottom>
                            <Typography
                                variant="subtitle1"
                                gutterBottom
                                sx={{

                                    color: '#545F71'
                                }}
                            >
                                Remarks</Typography>
                        </Typography>
                        <Typography
                            variant="body1"
                            dangerouslySetInnerHTML={{
                                __html: formatValue(testCaseData["Remarks"]).toString().replace(/\n/g, "<br>"),
                            }}
                        /> */}

                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2, mt: 2 }}>
                            <Tooltip title="Like" arrow>
                                <Box
                                    onClick={() => handleThumbClick("like")}
                                    sx={{
                                        cursor: "pointer",
                                        marginRight: 2,
                                        "&:hover": { color: "#49A3FF" },
                                    }}
                                >
                                    {activeThumb === "like" ? (
                                        <ThumbUpIcon sx={{ fontSize: "24px" }} />
                                    ) : (
                                        <ThumbUpOutlinedIcon sx={{ fontSize: "24px" }} />
                                    )}
                                </Box>
                            </Tooltip>

                            <Tooltip title="Dislike" arrow>
                                <Box
                                    onClick={() => handleThumbClick("dislike")}
                                    sx={{
                                        cursor: "pointer",
                                        marginRight: 2,
                                        "&:hover": { color: "#FF4842" },
                                    }}
                                >
                                    {activeThumb === "dislike" ? (
                                        <ThumbDownIcon sx={{ fontSize: "24px" }} />
                                    ) : (
                                        <ThumbDownOutlinedIcon sx={{ fontSize: "24px" }} />
                                    )}
                                </Box>
                            </Tooltip>
                            <CommonCopy contentToCopy={testCaseData} />


                        </Box>
                    </Box>
                }
                buttons={[
                    // ...downloadButton,
                    ...nextButton,
                    // ...rpfDownloadButton

                    // {
                    //     label: "Generate Feature File",
                    //     variant: "contained",
                    //     onClick: handleGenerateFeatureFile,
                    //     startIcon: <GenerateButton />,
                    // }
                ]}

                fullScreenMode={true}
                type={"output"}
                defaultExpanded={defaultTestCasesExpanded}


            />

            <CommonDownload open={downloadOpen} onClose={handleCloseDownload}
                wordData={[
                    {
                        type: "subParagraphs",
                        data: testCaseData,
                    },
                ]}
                serviceName={"Test Case Details"}
                serviceResponse={formatTestPlan(testCaseData)}
                documents={['xls', 'csv']}
            />

        </Box>
    );
};

export default APITestCaseImported;
